/**
 * Módulo: Carteira do Fundo
 * Ativa Swiper apenas quando há mais de 3 cards.
 */

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initCarteiraFundo() {
	document.querySelectorAll('[data-carteira-fundo]').forEach( wrapper => {
		const swiperEl = wrapper.querySelector('[data-carteira-swiper]');
		if ( ! swiperEl || ! swiperEl.classList.contains('swiper') ) return;

		const prevEl = wrapper.querySelector('.carteira-fundo__btn--prev');
		const nextEl = wrapper.querySelector('.carteira-fundo__btn--next');

		new Swiper( swiperEl, {
			modules: [ Navigation ],
			slidesPerView: 1,
			spaceBetween: 24,
			loop: false,
			navigation: { prevEl, nextEl },
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 40,
				},
			},
		} );
	} );
}
